import { useState, useEffect } from 'react';
import { Button } from '../input';
import { Pill } from '../pill';
import { TableFromObject } from '../table';

const formatUsd = (it) => '$' + it.toFixed(4);
const percent = (val, job) => ((100 * (val || 0)) / job.metrics.cost.total).toFixed(1) + '%';

const Expanded = ({ job, k, showPercent }) => {
  const style = {
    fontFamilyx: 'monospace',
    textAlign: 'right',
    padding: '2px 4px',
    fontSizex: 12,
  };

  const thStyle = {
    padding: '2px 4px',
  };

  if (k == 'ai') {
    const nodes = job.metrics[k].map((item, idx) => {
      const rows = [
        <tr key={1}>
          <th style={thStyle}>unit</th>
          <th style={thStyle}>input</th>
          <th style={thStyle}>output</th>
          <th style={thStyle}>total</th>
          {showPercent && <th style={thStyle}>% cost</th>}
        </tr>,

        <tr key={2}>
          <td style={style}>usd</td>
          <td style={style}>{formatUsd(item.cost.input)}</td>
          <td style={style}>{formatUsd(item.cost.output)}</td>
          <td style={style}>{formatUsd(item.cost.total)}</td>
          {showPercent && <td style={style}>{percent(item.cost.total, job)}</td>}
        </tr>,

        <tr key={3}>
          <td style={style}>tokens</td>
          <td style={style}>{item.tokens.input}</td>
          <td style={style}>{item.tokens.output}</td>
          <td style={style}>{item.tokens.total}</td>
          {showPercent && <td style={style}></td>}
        </tr>,
      ];

      return (
        <div key={idx}>
          <div style={{ marginBottom: 5 }}>
            <b>{item.model}</b>
          </div>
          <table>
            <tbody>{rows}</tbody>
          </table>
        </div>
      );
    });

    return <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>{nodes}</div>;
  } else if (k == 'network') {
    const rows = job.metrics[k].map((item, idx) => (
      <tr key={idx}>
        <td style={style}>{item.tier}</td>
        <td style={style}>{(item.bytes / 1e6).toFixed(2)}</td>
        <td style={style}>{formatUsd(item.cost)}</td>
        {showPercent && <td style={style}>{percent(item.cost, job)}</td>}
      </tr>
    ));
    return (
      <div>
        <table>
          <thead>
            <tr>
              <th style={thStyle}>tier</th>
              <th style={thStyle}>mb</th>
              <th style={thStyle}>cost</th>
              {showPercent && <th style={thStyle}>% cost</th>}
            </tr>
          </thead>
          <tbody>{rows}</tbody>
        </table>
      </div>
    );
  } else if (k == 'fetchfox') {
    const rows = job.metrics[k].map((item, idx) => (
      <tr key={idx}>
        <td style={style}>{item.path}</td>
        <td style={style}>{item.count}</td>
        <td style={style}>{formatUsd(item.cost)}</td>
        {showPercent && <td style={style}>{percent(item.cost, job)}</td>}
      </tr>
    ));
    return (
      <div>
        <table>
          <thead>
            <tr>
              <th style={thStyle}>operation</th>
              <th style={thStyle}>count</th>
              <th style={thStyle}>cost</th>
              {showPercent && <th style={thStyle}>% cost</th>}
            </tr>
          </thead>
          <tbody>{rows}</tbody>
        </table>
      </div>
    );
  } else {
    return (
      <div>
        <pre>{JSON.stringify(job.metrics[k], null, 2)}</pre>
      </div>
    );
  }
};

export const Cost = ({ job, expanded, field }) => {
  const [expanded_, setExpanded_] = useState({});

  if (!job) {
    return null;
  }

  const cost = job.metrics?.cost || {};

  let nonZero = 0;
  let total = 0;
  const clean = {};
  for (const key of Object.keys(cost)) {
    const val = cost[key] || 0;
    total += val;
    if (val) {
      nonZero++;
    }
    clean[key] = formatUsd(val);
  }
  const showPercent = nonZero > 2; // 1 is from total

  const len = job.results?.items?.length;
  if (len && cost.total) {
    clean['per 1k'] = formatUsd((cost.total / len) * 1000);
  }

  const toggle = (key) => {
    const copy = { ...expanded_ };
    copy[key] = !copy[key];
    setExpanded_(copy);
  };

  const nodes = Object.keys(cost).map((key, idx) => {
    if (field && key != field) {
      return;
    }
    const background = idx % 2 == 0 ? '#f3f3f3' : '#fff';
    return (
      <div
        onClick={() => toggle(key)}
        style={{
          display: 'flex',
          alignItems: 'flex-start',
          padding: 10,
          fontSize: 13,
          gap: 20,
          cursor: expanded || key == 'total' ? null : 'pointer',
          background,
        }}
      >
        <div style={{ width: 80, fontWeight: 'bold' }}>
          <Pill blue>{key}</Pill>
        </div>
        <div>{clean[key]}</div>
        {total && <div style={{ textAlign: 'right', width: 60 }}>{percent(cost[key], job)}</div>}
        {(expanded || expanded_[key]) && <Expanded job={job} k={key} showPercent={showPercent} />}
      </div>
    );
  });

  return (
    <div>
      {nodes}
      {/*
      <pre>{JSON.stringify(job, null, 2)}</pre>
      <TableFromObject obj={clean} />
      */}
    </div>
  );
};
